import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';

import { useObservable } from '@lib/common';
import { sessionQuery, sessionService } from '@lib/state';

export const SignOutPage: React.FC = () => {
  const isLoggedIn = useObservable(sessionQuery.isLoggedIn, 'async');

  useEffect(() => {
    sessionService.logout();
  }, []);

  if (isLoggedIn) return null;

  return <Redirect to="/account/signin" />;
};
